var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFavoriteWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid",
    width: 200,
    height: 200,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "ldl-scale"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#eee",
    d: "M50 87.108L13.293 46.26c-7.383-8.216-6.708-20.861 1.508-28.244 8.217-7.382 20.861-6.708 28.244 1.508L50 27.263l6.955-7.74c7.383-8.216 20.029-8.89 28.244-1.508 8.216 7.383 8.891 20.028 1.508 28.244L50 87.108z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavoriteWhite);
export default __webpack_public_path__ + "static/media/favorite-white.ef82cbfba4cba6d4be7eb2591b231694.svg";
export { ForwardRef as ReactComponent };